function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import TableRow from "./AnalyticsTableRow";

class AnalyticsTableBody extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "getClassName", () => {
      return "admin-analytics-table__body";
    });

    _defineProperty(this, "renderRow", (row, index) => {
      const _this$props = this.props,
            dimensionHeaders = _this$props.dimensionHeaders,
            metricHeaders = _this$props.metricHeaders,
            totals = _this$props.totals,
            sortBy = _this$props.sortBy,
            urlPattern = _this$props.urlPattern;
      return React.createElement(TableRow, _extends({}, row, {
        urlPattern: urlPattern,
        dimensionHeaders: dimensionHeaders,
        metricHeaders: metricHeaders,
        totals: totals,
        sortBy: sortBy,
        key: index
      }));
    });
  }

  render() {
    const _this$props2 = this.props,
          rows = _this$props2.rows,
          sortedRows = _this$props2.sortedRows;
    const className = this.getClassName();
    return React.createElement("tbody", {
      className: className
    }, sortedRows.map(this.renderRow));
  }

}

_defineProperty(AnalyticsTableBody, "defaultProps", {
  rows: []
});

export default AnalyticsTableBody;